import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from 'app/shared/app-features/models/features.enum';

@Injectable()
export class FormErrorHandlingOnTouchedFeature implements IFlagFeature {
  name = Features.FORM_ERROR_HANDLING_ON_TOUCHED;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
